import {useEffect, useState} from 'react';
import Overlay from 'infrastructure/js/components/Overlay/overlay';
import ArrowLeftIcon from 'infrastructure/assets/svg/tab-arrow-left.svg';
import SelectAllIcon from '../../../../assets/svg/select-all.svg';
import RfidIcon from 'infrastructure/assets/svg/scanner.svg';
import DeleteIcon from '../../../../assets/svg/delete-icon-black.svg';
import useLabels from 'infrastructure/js/hooks/useLabels';
import MobileHeader from '../Common/MobileHeader/mobileHeader';
import MoveAssetsListItem from '../MoveAssetsListItem/moveAssetsListItem';
import MobileBottom from '../Common/MobileBottom/mobileBottom';
import ScannedAssetDetails from '../ScannedAssetDetails/scannedAssetDetails';
import MoveAssetsChangeLocation from '../MoveAssetsChangeLocation/moveAssetsChangeLocation';
import MoveAssetsResultPage from '../MoveAssetsResultPage/moveAssetsResultPage';
import FullScreenToggle from 'infrastructure/js/components/FullScreenToggle/fullScreenToggle';
import { Route, Switch } from 'react-router-dom';
import useRedux from 'infrastructure/js/hooks/useRedux';
import { jsxActions as moveAssetsPageActions } from '../../../actions/Mobile/MoveAssetsPage/moveAssetsPageActions';
import RfidScanInput from 'infrastructure/js/components/RfidScanInput/rfidScanInput';

require('./moveAssetsPage.scss');

const tempImg = require('images/scan-illustration.png');

function concatenateAndUpdateArrays(existingArray, newArray, key) {
  const existingMap = new Map(existingArray.map(item => [item[key], item]));

  newArray.forEach((newItem) => {
    if (existingMap.has(newItem[key])) {
      const existingObj = existingMap.get(newItem[key]);
      Object.assign(existingObj, newItem);
    } else {
      existingArray.unshift(newItem);
    }
  });
  return existingArray;
}

function getSelectedItems(items) {
  return items?.filter?.(item => item.selected) ?? [];
}

const getState = (state) => {
  return {}
}

const allActions = {
...moveAssetsPageActions,
}


export default function MoveAssetsPage (props) {

  const { state, actions } = useRedux(allActions, getState);
  const [scanMode, setScanMode] = useState(false);
  const [selectAllMode, setSelectAllMode] = useState(false);
  const [submitResult, setSubmitResult] = useState({});
  const [scannedItems, setScannedItems] = useState([]);
  const [locations, setLocations] = useState([]);
  const [assetDetails, setAssetDetails] = useState(false);
  const [loading, setLoading] = useState(false);

  const labels = useLabels('mat.mobile.moveAssetsPage.');

  useEffect(() => {
    actions?.init().then((result) => {
        const locations = result.map((item) => {
          return {value: item.id, label: item.name}
        });
        setLocations(locations);
      }
    );
  }, []);

  const onSubmit = (data) => {
    setLoading(true);
    let ids = getSelectedItems(scannedItems)?.map(item => item.id);
    let newData = {
      assetIds : ids,
      destination: data?.value,
      ignoreValidationWarnings: true
    };

    actions.submit(newData).then(
      (result) => {
        onSubmitCallback(result);
      })
  };

  const onSubmitCallback = (result) => {
    setLoading(false);
    setScannedItems([]);
    setSubmitResult(result);
    setSelectAllMode(false);

    const path = '/MoveAssets/completed';
    props.history.push(path);
  };

  const onBottomClick = () => {
    let path = '/MoveAssets/changeLocation';
    props.history.push(path);
  };

  const onGoBack = () => {
    if (!scannedItems?.length) {
      props.history.push('/Mobile');
      return;
    }
    actions.processWithConfirmation(labels.get('confirmation.lose.assets'), onGoBackCallback);
  }

  const onGoBackCallback = () => {
    props.history.push('/Mobile');
  }

  const onSelectAllItems = () => {
    if (!scannedItems?.length) {
      return;
    }

    const newItems = scannedItems.map(item => {return {...item, selected: !selectAllMode}});
    setScannedItems(newItems);
    setSelectAllMode((value) => !value);
  }

  const onRemoveSelectedItems = () => {
    const selectedItems = getSelectedItems(scannedItems);
    if (!selectedItems?.length) {
      return;
    }
    actions.processWithConfirmation(labels.get('confirmation.remove.assets'), removeSelectedItemsCallback);
  }

  const removeSelectedItemsCallback = () => {
    const unselectedItems = scannedItems.filter(item => !item.selected);
    setScannedItems(unselectedItems);
    setSelectAllMode(false);
  }

  const onScanMode = () => {
    setScanMode(value => !value);
  }

  const onScanInputChangedHandler = (inputValue) => {
    setLoading(true);
    actions.getMultiAssetsDetails(inputValue).then(
    (assets) => {
      onGetMultiAssetsDetailsCallback(assets);
    })
  }

  const onGetMultiAssetsDetailsCallback = (assets) => {
    if (!assets?.length) {
      setLoading(false);
      return;
    }
    const existingAssets = [...scannedItems];
    const newAssets = assets.map(a => a.data);
    const items = concatenateAndUpdateArrays(existingAssets, newAssets, 'id');

    const selectedNum = getSelectedItems(items)?.length ?? 0;
    if (selectAllMode && selectedNum !== items.length) {
      setSelectAllMode(false);
    }
    setScannedItems(items);
    setLoading(false);
  }

  const getScanInputComponent = (props) => {
    return (
      <RfidScanInput isFocused={scanMode}
                     onScanInputChanged={onScanInputChangedHandler}
                     className="mobile-header-item"
                     {...props}
      />
    )
  }

  const getHeaderItems = () => {
    return {
      buttons: [
        {
          id: 'leftButton',
          icon: ArrowLeftIcon,
          className: 'divider-right',
          action: onGoBack,
        },
        {
          id: 'selectAllButton',
          icon: SelectAllIcon,
          className: selectAllMode ? 'active' : scannedItems?.length ? '' : 'disabled',
          action: onSelectAllItems,
        },
        {
          id: 'deleteButton',
          icon: DeleteIcon,
          className: getSelectedItems(scannedItems)?.length ? '' : 'disabled',
          action: onRemoveSelectedItems,
        },
        {
          id: 'scanInputButton',
          icon: RfidIcon,
          action: onScanMode,
          buttonComponent: getScanInputComponent,
        },
        {
          id: 'fullScreenButton',
          className: 'divider-left',
          buttonComponent: FullScreenToggle,
        },
      ]
    };
  };

  const getBottomItems = () => {
    const selectedNum = getSelectedItems(scannedItems)?.length ?? 0;
    const allNum = scannedItems?.length ?? 0;
    return {
      buttons: [
        {
          id: 'changeLocationButton',
          action: onBottomClick,
          className: selectedNum ? '' : 'disabled',
          label: labels.get('bottom.button.changeLocation') + `\n ${selectedNum}/${allNum}`,
      },
      ]
    };
  };

  const onAssetClickHandler = (id) => {
    if (id) {
      const found = scannedItems.find(item => item.id === id);
      if (found) {
        setAssetDetails(found);
        const path = `/MoveAssets/asset/${found.id}`;
        props.history.push(path);
      }
    }
  }

  const onItemClickHandler = (id) => {
    const newItems = scannedItems.map(item => {
      if (item.id === id) {
        item.selected = !item.selected;
        if (!item.selected) {
          setSelectAllMode(false);
        }
      }
      return item;
    });
    setScannedItems(newItems);
  }

  let assetsList = scannedItems.map((asset, index) => {
    return (
        <MoveAssetsListItem asset={asset} key={asset.id}
                            onAssetClickCallback={onAssetClickHandler}
                            onClickHCallback={onItemClickHandler}/>
    );
  });

  const renderPrompt = () => {
    if (!scannedItems?.length) {
      return scanMode ?
        <div className="section prompt-text">
          <label>{labels.get('prompt.readyForScan.text')}</label>
        </div>
        :
        <>
        <div className="section prompt-text">
          <label>{labels.get('prompt.info.text.start')}</label>
          <span className="prompt-icon"><RfidIcon/></span>
          <label>{labels.get('prompt.info.text.end')}</label>
        </div>
          <div className="section barcode-image">
            <img src={tempImg} alt="Plataine Logo" className="pointer"/>
          </div>
        </>
    }
    return null;
  }


  return (
  <div className="move-assets-page" tabIndex="-1">

    <Switch>
      <Route key='scannedAssetDetailsKey' exact path={'/MoveAssets/asset/:assetId/'}>
        <ScannedAssetDetails asset={assetDetails} history={props.history}/>
      </Route>

      <Route key='changeLocationKey' exact path={'/MoveAssets/changeLocation'}>
        <>
          <MoveAssetsChangeLocation locations={locations}
                                    assets={getSelectedItems(scannedItems)}
                                    history={props.history}
                                    onClickCallback={onSubmit}
          />
          {loading ? <Overlay.Loading/> : null}
        </>
      </Route>

      <Route key='scannedAssetDetailsKey' exact path={'/MoveAssets/completed'}>
        <MoveAssetsResultPage result={submitResult} history={props.history}/>
      </Route>

      <Route key='kitTypesFormKey' path={props.match.path}>
        <>
          <MobileHeader {...getHeaderItems()} />
          <div className="mobile-content">
            {assetsList}
            {renderPrompt()}
          </div>
          <MobileBottom {...getBottomItems()}/>
          {loading ? <Overlay.Loading/> : null}
        </>
      </Route>
    </Switch>
  </div>
  );
}

MoveAssetsPage.propTypes = {};


